/* HiDream v9 — scene switching for sections/hd-scenes.liquid.
   Every scene is already in the HTML; this only moves the "is-on" state, recolours the
   page (body[data-hd-scene]) and drives the optional autoplay. */
(() => {
  const root = document.querySelector('[data-hd9]');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Reveal on scroll (all HD v9 sections) */
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
  $$('.hd9 [data-r]').forEach((el) => io.observe(el));

  /* Cart notification: free-shipping progress from the live cart ($59 rule) */
  const shipSlot = document.querySelector('[data-hd9-ship-slot]');
  const renderShip = (cart) => {
    if (!shipSlot || !cart) return; const t = 5900; const left = t - cart.total_price; const pct = Math.min(100, Math.round((cart.total_price / t) * 100));
    const fmt = (c) => '$' + (c / 100).toFixed(2);
    shipSlot.innerHTML = `<div class="hd9-ship"><p class="hd9-ship__t">${left > 0 ? `You're <b>${fmt(left)}</b> away from free standard shipping.` : '<b>Free standard shipping</b> unlocked for this order.'}</p><div class="hd9-ship__bar" aria-hidden="true"><i style="width:${pct}%"></i></div></div>`;
  };
  if (shipSlot && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(renderShip).catch(() => {}); });
  }

  /* Cart drawer add-ons: add one variant, then re-render the drawer the way Dawn's product form does */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-hd9-addon]'); const drawer = document.querySelector('cart-drawer');
    if (!btn || !drawer || typeof drawer.renderContents !== 'function') return;
    btn.setAttribute('aria-busy', 'true');
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(`${addUrl}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.hd9Addon), quantity: 1 }], sections: drawer.getSectionsToRender().map((s) => s.id), sections_url: location.pathname }),
    }).then((r) => r.json()).then((res) => {
      if (res.status || !res.sections) { btn.removeAttribute('aria-busy'); return; }
      drawer.renderContents(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hd9-addon', cartData: res });
    }).catch(() => btn.removeAttribute('aria-busy'));
  });

  /* Keep the buy-column size summary in step with the selected size */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
      const d = ev && ev.data; if (!d || !d.html) return;
      const id = `hd9-specmini-${d.sectionId}`; const fresh = d.html.getElementById(id); const cur = document.getElementById(id);
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      const v = d.variant; const table = document.querySelector('[data-hd9-sizes]');
      if (v && table) { const opts = (v.options || []).map((o) => String(o).toUpperCase()); table.querySelectorAll('tr[data-size]').forEach((tr) => tr.classList.toggle('is-current', opts.includes(tr.dataset.size))); }
    });
  }

  /* Size & fit: in/lb ↔ cm/kg */
  $$('[data-hd9-units]').forEach((box) => box.querySelectorAll('[data-hd9-unit]').forEach((b) => b.addEventListener('click', () => {
    box.dataset.hd9Units = b.dataset.hd9Unit;
    box.querySelectorAll('[data-hd9-unit]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
  })));

  /* Detail clips: load and play only while on screen; rail arrows; full demo dialog */
  const clipIO = new IntersectionObserver((es) => es.forEach((e) => {
    const v = e.target; const src = v.querySelector('source[data-src]');
    if (e.isIntersecting) { if (src) { src.src = src.dataset.src; src.removeAttribute('data-src'); v.load(); } if (!reduce) v.play().catch(() => {}); }
    else v.pause();
  }), { threshold: 0.4 });
  $$('[data-hd9-clip]').forEach((v) => clipIO.observe(v));
  $$('.hd9-motion').forEach((sec) => {
    const rail = sec.querySelector('[data-hd9-rail]');
    sec.querySelectorAll('[data-hd9-rail-dir]').forEach((b) => b.addEventListener('click', () => {
      const card = rail && rail.children[0]; if (!card) return;
      rail.scrollBy({ left: Number(b.dataset.hd9RailDir) * (card.getBoundingClientRect().width + 16), behavior: reduce ? 'auto' : 'smooth' });
    }));
    const dlg = sec.querySelector('[data-hd9-full]'); const open = sec.querySelector('[data-hd9-full-open]');
    if (dlg && open) {
      const fv = dlg.querySelector('video');
      open.addEventListener('click', () => { dlg.showModal(); if (fv) fv.play().catch(() => {}); });
      const close = () => { if (fv) fv.pause(); dlg.close(); };
      dlg.querySelector('[data-hd9-full-close]').addEventListener('click', close);
      dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
      dlg.addEventListener('close', () => fv && fv.pause());
    }
  });

  /* Product video chapters */
  $$('.hd9-video').forEach((sec) => {
    const v = sec.querySelector('video'); const btns = $$('[data-hd9-seek]', sec); if (!v || !btns.length) return;
    btns.forEach((b) => b.addEventListener('click', () => { v.currentTime = Number(b.dataset.hd9Seek) || 0; v.play().catch(() => {}); }));
    v.addEventListener('timeupdate', () => { let cur = null; btns.forEach((b) => { if (v.currentTime >= Number(b.dataset.hd9Seek)) cur = b; }); btns.forEach((b) => b.classList.toggle('is-on', b === cur)); });
  });

  /* Scene pages: hero entrance, words that light up, gentle parallax */
  const shero = document.querySelector('[data-hd9-shero]');
  if (shero) {
    const im = shero.querySelector('img');
    const go = () => requestAnimationFrame(() => shero.classList.remove('is-pre'));
    if (reduce || !im) go(); else Promise.race([im.decode ? im.decode().catch(() => {}) : Promise.resolve(), new Promise((r) => setTimeout(r, 1200))]).then(go);
  }
  const words = $$('[data-hd9-words]');
  words.forEach((el) => { el.innerHTML = el.textContent.trim().split(/\s+/).map((w) => `<span class="w">${w}</span>`).join(' '); });
  const pars = reduce ? [] : $$('[data-hd9-par]');
  if (words.length || pars.length) {
    let ticking = false;
    const frame = () => {
      ticking = false; const vh = innerHeight;
      words.forEach((el) => {
        const r = el.getBoundingClientRect(); const ws = el.querySelectorAll('.w');
        const p = reduce ? 1 : Math.min(1, Math.max(0, (vh * 0.88 - r.top) / (vh * 0.55)));
        ws.forEach((w, i) => w.style.setProperty('--o', Math.min(1, Math.max(0.16, p * ws.length - i + 0.16)).toFixed(2)));
      });
      pars.forEach((el) => {
        const r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
        const f = Number(el.dataset.hd9Par) || 0; const off = (r.top + r.height / 2 - vh / 2) * -f;
        el.style.transform = `translate3d(0, ${off.toFixed(1)}px, 0)`;
      });
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    addEventListener('resize', frame); frame();
  }

  /* Long product descriptions open clamped, with a control to show everything */
  $$('.hd9-acc .rte[data-clamp]').forEach((el) => {
    if (el.scrollHeight < 640) return;
    el.classList.add('is-clamped');
    const b = document.createElement('button'); b.type = 'button'; b.className = 'hd9-more-btn'; b.textContent = 'Show all details'; b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', () => { const open = el.classList.toggle('is-clamped') === false; b.textContent = open ? 'Show less' : 'Show all details'; b.setAttribute('aria-expanded', String(open)); if (!open) el.closest('details').scrollIntoView({ block: 'start' }); });
    el.after(b);
  });

  /* Shop panel also opens on hover with a fine pointer; Dawn's header-menu handles click and keyboard */
  const shop = document.querySelector('.hd9-navshop details');
  if (shop && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let t; const li = shop.closest('.hd9-navshop');
    li.addEventListener('mouseenter', () => { clearTimeout(t); shop.setAttribute('open', ''); shop.querySelector('summary').setAttribute('aria-expanded', 'true'); });
    li.addEventListener('mouseleave', () => { t = setTimeout(() => { shop.removeAttribute('open'); shop.querySelector('summary').setAttribute('aria-expanded', 'false'); }, 160); });
  }

  /* Mobile add-to-cart bar: appears once the main button has scrolled away */
  const bar = document.querySelector('[data-hd9-sticky]');
  if (bar) {
    bar.classList.add('hd9'); document.body.appendChild(bar); /* out of any transformed ancestor, so "fixed" means the viewport */
    const btn = document.getElementById(bar.dataset.hd9Sticky);
    const price = bar.querySelector('.hd9-sticky__t span');
    if (btn) {
      let ticking = false;
      const check = () => { ticking = false; const b = document.getElementById(bar.dataset.hd9Sticky); if (!b) return; const on = b.getBoundingClientRect().bottom < 0; if (on === bar.classList.contains('is-on')) return; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); bar.querySelector('button').tabIndex = on ? 0 : -1; };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true }); check();
      bar.querySelector('button').addEventListener('click', () => { const b = document.getElementById(bar.dataset.hd9Sticky); if (b && !b.disabled) b.click(); else if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, (ev) => { const v = ev.data && ev.data.variant; if (v && price) price.textContent = '$' + (v.price / 100).toFixed(2); });
  }

  /* Details chapter: product-sheet images stay folded until asked for */
  document.querySelectorAll('[data-hd9-sheet-btn]').forEach((b) => b.addEventListener('click', () => {
    const box = b.closest('.hd9-pdet__r'); const open = box.classList.toggle('show-sheet');
    b.setAttribute('aria-expanded', String(open)); b.textContent = open ? 'Hide the product sheet images' : 'Show the product sheet images';
  }));

  /* Product film: on desktop the section pins and vertical scroll moves the film sideways */
  document.querySelectorAll('[data-hd9-reel]').forEach((reel) => {
    const track = reel.querySelector('[data-hd9-reel-track]'); const n = reel.querySelector('[data-hd9-reel-n]'); const bar = reel.querySelector('[data-hd9-reel-bar]');
    const frames = [...track.children];
    const label = (p) => { if (n) n.textContent = String(Math.min(frames.length, Math.round(p * (frames.length - 1)) + 1)).padStart(2, '0'); if (bar) bar.style.setProperty('--p', Math.max(1 / frames.length, p)); };
    const size = () => {
      const wide = innerWidth >= 990 && !reduce && reel.dataset.pin === 'true'; reel.classList.toggle('is-pinned', wide);
      if (!wide) { reel.style.height = ''; track.style.transform = ''; return; }
      const travel = Math.max(0, track.scrollWidth - innerWidth); reel.style.height = `${innerHeight + travel}px`;
    };
    const move = () => {
      if (!reel.classList.contains('is-pinned')) { const max = track.scrollWidth - track.clientWidth; label(max > 0 ? track.scrollLeft / max : 0); return; }
      const travel = Math.max(0, track.scrollWidth - innerWidth); const r = reel.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -r.top / Math.max(1, reel.offsetHeight - innerHeight)));
      track.style.transform = `translate3d(${-p * travel}px,0,0)`; label(p);
    };
    size(); move();
    addEventListener('resize', () => { size(); move(); }); addEventListener('load', () => { size(); move(); });
    addEventListener('scroll', move, { passive: true }); track.addEventListener('scroll', move, { passive: true });
    reel.querySelectorAll('[data-hd9-reel-dir]').forEach((b) => b.addEventListener('click', () => {
      const step = (frames[0] ? frames[0].getBoundingClientRect().width : 400) + 16;
      track.scrollBy({ left: Number(b.dataset.hd9ReelDir) * step, behavior: reduce ? 'auto' : 'smooth' });
    }));
  });

  if (!root) return;
  const keys = $$('.hd9-tab', root).map((t) => t.dataset.scene);
  let cur = root.dataset.first;
  document.body.dataset.hdScene = cur;

  const show = (key) => {
    if (key === cur || !keys.includes(key)) return;
    cur = key; document.body.dataset.hdScene = key;
    $$('.hd9-tab', root).forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.scene === key)));
    $$('.hd9-way', root).forEach((w) => w.classList.toggle('is-now', w.dataset.go === key));
    $$('[data-panel]', root).forEach((p) => {
      const on = p.dataset.panel === key;
      if (on) { p.classList.remove('was-on'); p.classList.add('is-on'); p.removeAttribute('aria-hidden'); }
      else if (p.classList.contains('is-on')) {
        p.classList.remove('is-on', 'live'); p.classList.add('was-on');
        if (!p.classList.contains('hd9-layer')) p.setAttribute('aria-hidden', 'true');
        setTimeout(() => p.classList.remove('was-on'), reduce ? 0 : 1400);
      }
      p.querySelectorAll('a').forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
    });
    const main = root.querySelector(`.hd9-hero__main .hd9-layer[data-panel="${key}"]`);
    if (main) setTimeout(() => main.classList.contains('is-on') && main.classList.add('live'), reduce ? 0 : 1300);
    try { const u = new URL(location.href); u.searchParams.set('scene', key); history.replaceState(history.state, '', u); } catch (e) {}
  };

  /* Autoplay while the hero is in view; it stops for good once a visitor chooses */
  const DUR = Number(root.dataset.dur) || 8000; const auto = root.dataset.autoplay === 'true';
  let t0 = 0, raf = 0, chosen = !auto, hover = false, inView = true, elapsed = 0;
  const tick = (now) => {
    if (!t0) t0 = now - elapsed; elapsed = now - t0;
    const tab = root.querySelector(`.hd9-tab[data-scene="${cur}"]`); if (tab) tab.style.setProperty('--p', Math.min(1, elapsed / DUR));
    if (elapsed >= DUR) { elapsed = 0; t0 = 0; show(keys[(keys.indexOf(cur) + 1) % keys.length]); }
    raf = requestAnimationFrame(tick);
  };
  const run = () => { cancelAnimationFrame(raf); t0 = 0; if (!chosen && !hover && inView && !document.hidden && !reduce) raf = requestAnimationFrame(tick); };
  const stop = () => { chosen = true; cancelAnimationFrame(raf); $$('.hd9-tab', root).forEach((t) => t.style.removeProperty('--p')); };
  const pick = (key, scroll) => { stop(); show(key); if (scroll) root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); };
  $$('.hd9-tab', root).forEach((t) => t.addEventListener('click', () => pick(t.dataset.scene)));
  $$('[data-go]', root).forEach((w) => w.addEventListener('click', (e) => { e.preventDefault(); pick(w.dataset.go, true); }));
  const hero = root.querySelector('.hd9-hero');
  hero.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hover = true; cancelAnimationFrame(raf); } });
  hero.addEventListener('pointerleave', () => { hover = false; run(); });
  hero.addEventListener('focusin', () => { hover = true; cancelAnimationFrame(raf); });
  hero.addEventListener('focusout', () => { hover = false; run(); });
  new IntersectionObserver(([e]) => { inView = e.isIntersecting; run(); }, { threshold: 0.35 }).observe(hero);
  document.addEventListener('visibilitychange', run);

  const q = new URLSearchParams(location.search).get('scene');
  if (q && keys.includes(q)) { chosen = true; root.classList.remove('is-intro'); show(q); }

  /* First load: headline, copy and image arrive in sequence */
  const first = root.querySelector('.hd9-hero__main .hd9-layer.is-on img');
  Promise.race([Promise.all([document.fonts.ready, first && first.decode ? first.decode().catch(() => {}) : 0]), new Promise((r) => setTimeout(r, 1400))])
    .then(() => requestAnimationFrame(() => { root.classList.remove('is-intro'); run(); }));

  /* Swash width follows the italic line */
  const fitSwash = () => $$('.hd9-copy', root).forEach((c) => { const em = c.querySelector('.ln:last-of-type em'); const sv = c.querySelector('.hd9-swash'); if (em && sv) sv.style.width = `${em.getBoundingClientRect().width * 0.94}px`; });
  document.fonts.ready.then(fitSwash); addEventListener('resize', fitSwash);

  /* Story: inset photo opens to full width while it scrolls in */
  const ex = root.querySelector('[data-expand]');
  if (ex) {
    const upd = () => { const r = ex.getBoundingClientRect(); const span = ex.offsetHeight - innerHeight; const p = Math.min(1, Math.max(0, -r.top / (span * 0.7))); ex.style.setProperty('--x', reduce ? 1 : p.toFixed(4)); };
    upd(); addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd);
  }

  /* The "View" disc follows the pointer inside product images */
  if (matchMedia('(hover: hover) and (pointer: fine)').matches && !reduce) root.addEventListener('pointermove', (e) => {
    const f = e.target.closest && e.target.closest('.hd9-card .hd9-frame'); if (!f) return;
    const r = f.getBoundingClientRect(); const v = f.querySelector('.hd9-view');
    v.style.translate = `${e.clientX - r.left - r.width / 2}px ${e.clientY - r.top - r.height / 2}px`;
  });
})();

/* PDP story: arrows move the close-up rail by one card */
document.addEventListener('click', (e) => {
  const btn = e.target.closest && e.target.closest('[data-hd9-rail-prev], [data-hd9-rail-next]'); if (!btn) return;
  const rail = btn.closest('.hd9-up') && btn.closest('.hd9-up').querySelector('[data-hd9-rail]'); if (!rail || !rail.firstElementChild) return;
  const step = rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0);
  rail.scrollBy({ left: btn.hasAttribute('data-hd9-rail-next') ? step : -step, behavior: 'smooth' });
});
